module.exports = __webpack_public_path__ + "img/logout.2dc1f7a2.svg";